<template>
    <div>
        <v-card-text class="catalog-list">
            <div class="group">
                <v-card-title class="cardTitle ml-2">
                  <span v-if="partTypeIsNotExist(partType)" slot="activator" class="primary--text toogleAllParts"  v-html="renderIcons(partType)"></span>
                  <span v-if="partTypeIsExist(partType)" slot="activator" class="primary--text toogleAllParts"  v-html="renderIcons(partType)"  @click="toggleAllSelected(partType)"></span>
                  <h4 class="ml-2">{{ groupTitle }}</h4>
               </v-card-title>
            </div>
            <v-divider></v-divider>
            <ul>
                <li :class="[{ 'active': inPartsBasket(part) }]" v-for="part in partType"
                    :key="`${part.id} - ${part.name}`">
                    <v-layout align-center :class="{ mobile: isMobile }">

                      <!-- CUANDO NO HAY TIPOS DE PARTES --->
                        <span v-if="partTypeIsNotExist(partType)"
                             class="mr-2 pa-1 pr-1 ml-1 px-1 "
                            v-html="renderIcon(part)"></span>

                        <v-flex v-if="partTypeIsNotExist(partType)" 
                        style="white-space: normal !important; word-wrap: break-word;" class=" pb-2 pt-2"
                        >
                            <span>{{ part.name }}</span>
                        </v-flex>
                        
                     
                        <!-- CUANDO SI HAY TIPOS DE PARTES --->
                        <span v-if="partTypeIsExist(partType)" class="mr-2 pa-1 pr-1 ml-1 px-1 "
                            v-html="renderIcon(part)"
                            @click="toggleSelectedUnique(part)"></span>

                        <v-flex v-if="partTypeIsExist(partType)" style="white-space: normal !important; word-wrap: break-word;" class=" pb-2 pt-2"
                        @click="toggleSelectedUnique(part)">
                            <span>{{ part.name }}</span>
                        </v-flex>
                        <v-flex shrink v-if="!isMobile" class="pb-2 pt-2">
                            <button @click="go(part)"
                                class="primary action  white--text text-xs-center pa-1 ">
                                <small>{{ $t("Catalog.go") }}</small>
                            </button>
                        </v-flex>
                        <v-flex shrink v-else class="pb-2 pt-2">
                            <button @click="go(part)" class=" text-xs-center pa-1 ">
                                <v-icon color="primary">search</v-icon>
                            </button>
                        </v-flex>
                    </v-layout>
                </li>
            </ul>
        </v-card-text>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    name: "PartTypeMobile",
    data(){
    return {
      toggleSelectedIcon: false,
      showUniqueParts: false,
      uniquepartDescriptions: []
    }
  },
    props: {
        partType: {
            type: Array,
        },
        isMobile: {
            type: Boolean,
        },
        categoryTitle: {
            type: String,
        },
        groupTitle: {
          type: String,
        },
        model: {
            type: String
        }
    },
    computed: {
        ...mapState({
            partsBasket: state => state.parts.partsBasket,
        }),
        ...mapGetters({
            totalGroupBasketCount: "parts/totalGroupBasketCount",
            basicCatalogRequest: 'parts/basicCatalogRequest',
            onlyGroups: 'parts/onlyGroups',

        })
    },
    methods: {
        ...mapActions({
            INQUIRY: "parts/INQUIRY",
            TOGGLE_SELECTION_SINGLE_PARTS_TYPES: "parts/TOGGLE_SELECTION_SINGLE_PARTS_TYPES",
            ACTIVE_PART_TYPES_ICON: "parts/ACTIVE_PART_TYPES_ICON",
            TOGGLE_SELECTION_ALL_PARTS_TYPES: "parts/TOGGLE_SELECTION_ALL_PARTS_TYPES",
            GET_UNIQUE_PART_DESCRIPTIONS: "parts/GET_UNIQUE_PART_DESCRIPTIONS",
            RESET_PARTS_TYPES: "parts/RESET_PARTS_TYPES",
            SET_UNIQUE_PART_DESCRIPTIONS_ARRAY: "parts/SET_UNIQUE_PART_DESCRIPTIONS_ARRAY",
            RESET_UNIQUE_PART_DESCRIPTIONS_ARRAY: "parts/RESET_UNIQUE_PART_DESCRIPTIONS_ARRAY"
        }),

        partTypeIsExist(partType){
          if(partType[0]?.name !== 'NO HAY TIPOS DE PARTES DISPONIBLES'){
            return true
          }
        },
        partTypeIsNotExist(partType){
          if(partType[0]?.name === 'NO HAY TIPOS DE PARTES DISPONIBLES'){
            return true
          }
        },
        renderIcon(part) {
            return this.inPartsBasket(part)
                ? '<i aria-hidden="true" class="v-icon material-icons primary--text">check_box</i>'
                : '<i aria-hidden="true" class="v-icon dark material-icons theme--light">check_box_outline_blank</i>';
        },
        renderIcons(partType){
          return this.inPartsBasketAll(partType)
            ? ('<i aria-hidden="true" class="v-icon material-icons">indeterminate_check_box</i>')
            : ('<i aria-hidden="true" class="v-icon dark material-icons theme--light">check_box_outline_blank</i>')
        },
        inPartsBasket(part) {
            return (
                this.partsBasket.findIndex(
                    i => i.id === parseInt(part.id)
                ) !== -1
            )
        },
        inPartsBasketAll(partType){
          if(!partType){
            return false
          }
          let count = 0;
          let partcount = 0
          partType.forEach(part => {
            const index = this.$store.state.parts[this.model].findIndex((i => i.id === parseInt(part.id)));
            if(index !== -1) {
              const partCountFinal = ++partcount
              count = partCountFinal
            }
          })
          if(count === partType.length){
            this.toggleSelectedIcon = true
            return true 
          } else {
            this.toggleSelectedIcon = false
            return false
          }
        },
        toggleParts(part){            
           this.$emit("Update", part)
        },
        toggleAllSelected(partType) {
          const uniquepartDescriptions = partType
          if(this.toggleSelectedIcon === false) {
            const type = 2
            this.TOGGLE_SELECTION_ALL_PARTS_TYPES({ model: 'partsBasket', uniquepartDescriptions, type});        
          } else if (this.toggleSelectedIcon === true){ 
            const type = 3
            this.TOGGLE_SELECTION_ALL_PARTS_TYPES({ model: 'partsBasket', uniquepartDescriptions, type});
          }
          this.ACTIVE_PART_TYPES_ICON();
        },
        selectPart(part){            
           this.$emit("click", part)
        },
        async go(part) {
            if (!this.inPartsBasket(part)) {
                this.TOGGLE_SELECTION_SINGLE_PARTS_TYPES({
                    model: this.model,
                    part
                });
            }
            await this.INQUIRY({request: this.basicCatalogRequest, page: 1, size: 25, group_by: 'manufacturer' });
        },
        renderIconUnique(part){
      return this.inPartsBasketUnique(part)
        ? ('<i aria-hidden="true" class="v-icon material-icons">check_box</i>')
        : ('<i aria-hidden="true" class="v-icon dark material-icons theme--light">check_box_outline_blank</i>')
    },
    renderAllIconsUnique(parts){
      return this.inPartsBasketAllUnique(parts)
        ? ('<i aria-hidden="true" class="v-icon material-icons">indeterminate_check_box</i>')
        : ('<i aria-hidden="true" class="v-icon dark material-icons theme--light">check_box_outline_blank</i>')
    },
    inPartsBasketUnique(part) {
      return (this.$store.state.parts[this.model].findIndex((i => i.id === parseInt(part.id)))) !== -1
    },
    inPartsBasketAllUnique(uniquepartDescriptions){
      let count = 0;
      let partcount = 0
      uniquepartDescriptions.forEach(part => {
        const index = this.$store.state.parts[this.model].findIndex((i => i.id === parseInt(part.id)));
        if(index !== -1) {
          const partCountFinal = ++partcount
          count = partCountFinal
    }
      })
      if(count === uniquepartDescriptions.length){
        this.toggleSelectedIcon = true
        return true 
      } else {
        this.toggleSelectedIcon = false
        return false
      }
    },

    toggleSelectedUnique(part) {
      const type = 'unique'
      this.$emit("click", { model: this.model, part, type });
    },

    toggleAllSelectedUnique(uniquepartDescriptions) {
      if(this.toggleSelectedIcon === false) {
        const type = 2
        const typeUnique = true
        const parts = [];
        this.TOGGLE_SELECTION_ALL_PARTS_TYPES({ model: 'partsBasket',parts, uniquepartDescriptions, type, typeUnique});        
      } else if (this.toggleSelectedIcon === true){ 
        const type = 3
        const typeUnique = true
        const parts = []
        this.TOGGLE_SELECTION_ALL_PARTS_TYPES({ model: 'partsBasket', parts, uniquepartDescriptions, type, typeUnique});
      }
      this.ACTIVE_PART_TYPES_ICON();
    },

    async uniquePartDescriptions(partType){
      const groups = this.onlyGroups.find(g => g.id === partType.group.id )

      const groupRequest = {
        vehicle: this.vehicleForInquiry,
        partGroups: [{
          id: groups.id,
          name: groups.name,
          engineCode: groups.engineCode
        }]
      }
      const response = await this.GET_UNIQUE_PART_DESCRIPTIONS(groupRequest)
      this.uniquepartDescriptions = response.data.items

      if(this.totalPartBasketCount > 0){
        this.RESET_PARTS_TYPES();
        this.toggleAllSelectedUnique(this.uniquepartDescriptions)
      }
      this.showUniqueParts = true
      
    },
    resetUniquePartDescriptions(){
      this.uniquepartDescriptions = [];
      this.RESET_UNIQUE_PART_DESCRIPTIONS_ARRAY();
      this.showUniqueParts = false
    }
    }

}
</script>
<style lang="stylus">
  .group
    display: flex
    flex: 1

  .toogleAllParts {
    cursor: pointer
  }

  .cardTitle{
    padding: 0px !important
    padding-bottom: 16px !important
  } 
</style>